import wind_preview from '../../../../../../asset/wind-preview.png'
import '../compass-overlay/index.scss'

class CompassOverlay3D {
  constructor(props) {
    this.iconUrl = props.iconUrl
    this.markerColor = props.markerColor || '9ECC3B'
    this.markerData = props.markerData
    this.windsData = props.windsData || []
    this.map = props.map || null
    this.updateWindsCallback = null
    this.container = null
    this.dirs = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw']
    this.dirDivs = []
  }

  buildContent(url, color) {
    let colorMarker = '#9ECC3B'
    if (color) {
      if (color.length <= 6) {
        colorMarker = color[0] === '#' ? color : '#' + color
      } else {
        colorMarker = color[0] === '#' ? color.substring(2) : '#' + color.substring(2)
      }
    }
    const imageUrl = url ? url.replace(/\s/g, '%20') : ''
    const content = document.createElement('div')
    content.classList.add('property')
    content.innerHTML = `
      <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <clipPath id="circleClipCompass3d">
            <circle cx="8" cy="6" r="5" />
          </clipPath>
        </defs>
        <rect width="16" height="16" fill="none"></rect>
        <path d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3S9.656,8,8,8z" fill="${colorMarker}"></path>
        <circle cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
        <image xlink:href="${imageUrl || 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'}" x="4" y="1.5" width="8" height="9" clip-path="url(#circleClipCompass3d)"></image>
      </svg>`
    return content
  }

  onselectwind(wind) {
    if (this.updateWindsCallback) {
      this.updateWindsCallback(wind)
    }
  }

  updateWinds(winds) {
    this.dirDivs.forEach(([dir, el]) => {
      el.style.visibility = winds && winds.indexOf(dir) !== -1 ? 'visible' : 'hidden'
    })
  }

  mount() {
    // Mount inside the map container so the overlay is scoped to the map area
    // and avoids z-index conflicts with the fixed left toolbar sidebar.
    const mountTarget = (this.map && this.map.getContainer)
      ? this.map.getContainer()
      : document.body

    const useAbsolute = mountTarget !== document.body

    const container = document.createElement('div')
    container.style.cssText = [
      `position:${useAbsolute ? 'absolute' : 'fixed'}`,
      'top:0',
      'left:0',
      `width:${useAbsolute ? '100%' : '100vw'}`,
      `height:${useAbsolute ? '100%' : '100vh'}`,
      'z-index:999',
      'background-image:radial-gradient(circle at 50% 50%, transparent 150px, rgba(0,0,0,0.75) 150px)',
    ].join(';')
    this._container = container

    const compass = document.createElement('div')
    compass.className = 'ideal-wind-compass'
    if (useAbsolute) compass.style.position = 'absolute'

    const pin = document.createElement('div')
    pin.className = 'ideal-wind-pin'
    if (!this.markerData.extendedData) {
      pin.appendChild(this.buildContent(this.iconUrl, this.markerColor))
    }

    this.dirDivs = []
    this.dirs.forEach(dir => {
      const img = document.createElement('img')
      img.src = wind_preview
      img.className = `ideal-wind-preview ${dir}-wind`
      compass.appendChild(img)
      this.dirDivs.push([dir, img])
    })

    const circleContainerParent = document.createElement('div')
    circleContainerParent.className = 'circle-container-parent'
    if (useAbsolute) circleContainerParent.style.position = 'absolute'

    const circleContainer = document.createElement('div')
    circleContainer.className = 'circle-container'

    this.dirs.forEach((item, i) => {
      const piece = document.createElement('div')
      piece.className = 'piece'
      piece.id = (i + 1).toString()
      piece.dataset.value = item
      circleContainer.appendChild(piece)
    })

    circleContainer.querySelectorAll('.piece').forEach(piece => {
      piece.addEventListener('click', e => {
        e.stopPropagation()
        this.onselectwind(e.target.dataset.value)
      })
    })

    pin.addEventListener('click', e => e.stopPropagation())
    compass.addEventListener('click', e => e.stopPropagation())

    circleContainerParent.appendChild(circleContainer)
    container.appendChild(compass)
    container.appendChild(pin)
    container.appendChild(circleContainerParent)

    mountTarget.appendChild(container)
    this.container = container
    this._compass = compass
    this._circleContainerParent = circleContainerParent
    this._pin = pin
    this.updateWinds(this.windsData)

    // Position the compass centered on the stand's screen coordinates
    // and keep it there as the map moves/rotates.
    this._updateCompassPosition = () => {
      if (!this.map || !this.markerData?.latitude || !this.markerData?.longitude) return
      const pt = this.map.project([this.markerData.longitude, this.markerData.latitude])
      const x = Math.round(pt.x), y = Math.round(pt.y)

      // Reposition compass, selection ring, and pin to the stand's screen position
      compass.style.position = 'absolute'
      compass.style.left = x + 'px'
      compass.style.top  = y + 'px'
      compass.style.marginLeft = ''
      compass.style.marginTop  = ''

      circleContainerParent.style.position = 'absolute'
      circleContainerParent.style.left = x + 'px'
      circleContainerParent.style.top  = y + 'px'

      pin.style.position = 'absolute'
      pin.style.left = x + 'px'
      pin.style.top  = y + 'px'

      // Move the dark vignette hole to the stand's position (percentage of container)
      const w = container.offsetWidth  || window.innerWidth
      const h = container.offsetHeight || window.innerHeight
      const pctX = (x / w * 100).toFixed(2) + '%'
      const pctY = (y / h * 100).toFixed(2) + '%'
      container.style.backgroundImage =
        `radial-gradient(circle at ${pctX} ${pctY}, transparent 150px, rgba(0,0,0,0.75) 150px)`

      // Apply bearing rotation (direction arrows track map rotation)
      const bearing = typeof this.map.getBearing === 'function' ? this.map.getBearing() : 0
      const rotation = `translate(-50%, -50%) rotate(${-bearing}deg)`
      compass.style.transform = rotation
      circleContainerParent.style.transform = rotation
      pin.style.transform = 'translate(-50%, -100%)'
    }

    this._updateCompassPosition()
    if (this.map) {
      this.map.on('move',   this._updateCompassPosition)
      this.map.on('rotate', this._updateCompassPosition)
    }
  }

  unmount() {
    if (this.map && this._updateCompassPosition) {
      this.map.off('move',   this._updateCompassPosition)
      this.map.off('rotate', this._updateCompassPosition)
    }
    if (this.container && this.container.parentElement) {
      this.container.parentElement.removeChild(this.container)
      this.container = null
    }
  }
}

export default CompassOverlay3D
